import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Guid } from "@/Common/Models/Guid";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";
import { Site } from "./ResponseModels/Site";
import { SitesModel } from "./SitesModel";

class SiteUIModel implements ICheckable {
    public Id: Guid = GuidHelper.Empty();
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Visible: boolean = true;
    public Model: Site;

    constructor(fields?: Partial<SiteUIModel>) {
        (Object as any).assign(this, fields);
    }

    public clone(): SiteUIModel {
        var clone = new SiteUIModel(this);

        if (this.Model)
            clone.Model = JSON.parse(JSON.stringify(this.Model));

        return clone;
    }

    public static FromCompositeObject(site: SitesModel): SiteUIModel {
        var o = new SiteUIModel();
        o.Id = site.Model.Id;
        o.Name = site.Model.ClinicalName;
        o.Visible = true;
        o.Model = site.Model;
        return o;
    }
}

export { SiteUIModel };
